import React from 'react'
import { connect } from 'react-redux'
import { Typography } from 'webbook-airways'

const mapStateToProps = ({ settings }) => ({ settings })
export const Authorization = connect(mapStateToProps)(
  ({ settings, allowedRoles, showPlaceholder, component, children }) => {
    if (
      !allowedRoles.some(allowedRole => settings.roles.includes(allowedRole))
    ) {
      return component || showPlaceholder ? (
        <div
          style={{
            flex: 1,
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <Typography variant="h5" color="primary">
            No access
          </Typography>
        </div>
      ) : null
    }
    return children
  }
)
